import axios from 'axios'

const AUTH_TOKEN = window.BtDevice?.getAuthorizationToken() || process.env.REACT_APP_API_TOKEN
const DEVICE_ID = window.BtDevice?.getDeviceId() || process.env.REACT_APP_DEVICE_ID

const ApiClient = axios.create({
  baseURL: 'https://api.bergregions.pl/api/',
  headers: {
    'Screen-Authorization': AUTH_TOKEN
  }
})

let appData = null
let appPromise = null

const fetchApp = () => {
  if (!appPromise) {
    appPromise = ApiClient.get(`v1/tv-app/device/${DEVICE_ID}`)
      .then(response => {
        appData = response.data

        setTimeout(() => {
          appPromise = null
          fetchApp().catch(console.error)
        }, 14 * 60 * 1000)

        return appData
      })
      .catch(error => {
        appPromise = null
        throw error
      })
  }
  return appPromise
}

fetchApp().catch(console.error)

const getAppId = async () => {
  const app = appData || await fetchApp()
  return app?.id || '74033586'
}

const API = {
  getApp: () => appData || fetchApp(),
  getMenuCategories: async () => {
    const appId = await getAppId()
    return ApiClient.get(`v1/qsr/${appId}/categories`)
  },
  getMenuItems: async ({ categoryId }) => {
    const appId = await getAppId()
    return ApiClient.get(`v1/qsr/${appId}/menu`, { params: categoryId })
  },
  createOrder: async payload => {
    const appId = await getAppId()
    return ApiClient.post(`v1/qsr/${appId}/order`, payload)
  },
  payforOrder: async ({ orderId }) => {
    const appId = await getAppId()
    return ApiClient.post(`/v1/qsr/${appId}/order/${orderId}/pay`)
  },
  getExternalDevices: () => ApiClient.get(`v1/device/external-devices?deviceId=${DEVICE_ID}`)
}

export default API
